import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import YesNo from "./YesNo.component";
import { FullWidthLine } from "../../../shared";
import { AiOutlineLeft } from "react-icons/ai";
import { useNavigate, useRevalidator } from "react-router-dom";

const data = {
  applies: [
    {
      question: "I have Medicaid coverage",
      tip: "Medicaid is a state-administered healthcare insurance program (jointly founded by states and the federal government) that sends payments to insurance providers for limited income citizens. These include low-income adults, the elderly, children and those with disabilities.",
    },
    {
      question:
        "I receive Veterans health care benefits through Veterans Affairs",
    },
  ],
  conditions: [
    { condition: "Diabetes" },
    { condition: "Heart Conditions" },
    { condition: "End-Stage Renal Disease (ESRD)" },
  ],
  importantPop:
    "There may be benefits to you for signing up for Medicare Advantage, even if you are covered under a group plan. Please be sure to check with your group plan administrator to learn more, and also to make sure that you won't lose your coverage by signing up for Medicare Advantage.",
};

const CoveragePart = () => {
  const navigate = useNavigate();
  const revalidator = useRevalidator();
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [isCoverage, setIsCoverage] = useState<boolean | undefined>();
  const [isVeteran, setIsVeteran] = useState<boolean | undefined>();
  const [isCSNP, setIsCSNP] = useState<boolean | undefined>();
  const [isDiabetes, setIsDiabetes] = useState<boolean | undefined>();
  const [isHeartConditions, setIsHeartConditions] = useState<
    boolean | undefined
  >();
  const [isESRD, setIsESRD] = useState<boolean | undefined>();

  useEffect(() => {
    sessionStorage.removeItem("isCoverage");
    sessionStorage.removeItem("isVeteran");
    sessionStorage.removeItem("isCSNP");
    sessionStorage.removeItem("isDiabetes");
    sessionStorage.removeItem("isHeartConditions");
    sessionStorage.removeItem("isESRD");
  }, []);

  const handleCoverageChange = (value: boolean) => {
    setIsCoverage(value);
  };

  const handleVeteranChange = (value: boolean) => {
    setIsVeteran(value);
  };

  const handleIsCSNP = (value: boolean) => {
    setIsCSNP(value);
  };

  const handleisDiabetes = (value: boolean) => {
    setIsDiabetes(value);
    value === true && setIsCSNP(value);
  };
  const handleisHeartConditions = (value: boolean) => {
    setIsHeartConditions(value);
    value === true && setIsCSNP(value);
  };
  const handleisESRD = (value: boolean) => {
    setIsESRD(value);
    value === true && setIsCSNP(value);
  };

  const togglePopup = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowPopup(!showPopup);
  };

  const goContinue = () => {
    if (isCoverage !== undefined) {
      sessionStorage.setItem("isCoverage", isCoverage.toString());
    }
    if (isVeteran !== undefined) {
      sessionStorage.setItem("isVeteran", isVeteran.toString());
    }
    if (isDiabetes !== undefined) {
      sessionStorage.setItem("isDiabetes", isDiabetes.toString());
    }
    if (isHeartConditions !== undefined) {
      sessionStorage.setItem("isHeartConditions", isHeartConditions.toString());
    }
    if (isESRD !== undefined) {
      sessionStorage.setItem("isESRD", isESRD.toString());
    }
    if (isDiabetes || isHeartConditions || isESRD) {
      sessionStorage.setItem("isCSNP", "true");
    } else if (
      isDiabetes === false ||
      isHeartConditions === false ||
      isESRD === false
    ) {
      sessionStorage.setItem("isCSNP", "false");
    }

    revalidator.revalidate();
    navigate("/get-recommendations/preferences");
  };

  return (
    <div className="grid-container ">
      <div className="grid-x show-for-small-only">
        <h2
          className="cell small-12 medium-8"
          style={{
            fontSize: 30,
            fontWeight: 600,
            lineHeight: "42px",
            textTransform: "uppercase",
            color: "#003A5D",
            paddingTop: 48,
          }}
        >
          Do any of these apply to you?
        </h2>
        <p
          className="cell small-12 medium-8"
          style={{
            fontSize: 25,
            fontWeight: 400,
            lineHeight: "32px",
            color: "#000",
            paddingTop: 8,
            paddingBottom: 16,
          }}
        >
          "If they do, great! We have plans that complement any of the
          circumstances below to fit your specific needs."
        </p>
        <div className="cell small-12">
          {data.applies.map((apply, index) => (
            <YesNo
              condition={apply.question}
              tip={apply.tip}
              key={index}
              onChange={
                index === 0 ? handleCoverageChange : handleVeteranChange
              }
            />
          ))}
        </div>
      </div>
      <div
        className="grid-x hide-for-small-only"
        style={{ padding: "72px 100px 58px 100px" }}
      >
        <h3
          className="cell small-12"
          style={{
            fontSize: 39,
            fontWeight: 600,
            lineHeight: "42px",
            textTransform: "uppercase",
            color: "#003A5D",
          }}
        >
          Do any of these apply to you?
        </h3>
        <p
          className="cell small-12"
          style={{
            fontSize: 25,
            fontWeight: 400,
            lineHeight: "32px",
            color: "#000",
            paddingTop: 14,
            paddingBottom: 59,
          }}
        >
          If they do, great! Alignment Health has plans that perfectly
          complement any of the circumstances below, so you’re able to choose
          the perfect fit for your specific needs.
        </p>
        <div className="cell small-12">
          {data.applies.map((apply, index) => (
            <YesNo
              condition={apply.question}
              key={index}
              tip={apply.tip}
              onChange={
                index === 0 ? handleCoverageChange : handleVeteranChange
              }
            />
          ))}
        </div>
      </div>
      <div
        className="hide-for-small-only"
        style={{ paddingLeft: 100, paddingRight: 100, paddingBottom: 38 }}
      >
        <h3
          style={{
            fontSize: 39,
            fontWeight: 600,
            lineHeight: "42px",
            textTransform: "uppercase",
            color: "#003A5D",
          }}
        >
          Do you have any of the following conditions?
        </h3>
        <div
          style={{
            paddingBottom: 46,
          }}
        >
          <button
            type="button"
            style={{
              color: "#1B54C2",
              textDecoration: "underline",
              cursor: "pointer",
              fontSize: 18,
            }}
            onClick={togglePopup}
          >
            Why is this important?
          </button>
        </div>
        {showPopup && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#F5F9FD",
              border: "1px solid #ccc",
              padding: "80px 56px",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
              zIndex: 9999,
              fontSize: 25,
              fontWeight: 400,
              lineHeight: "32px",
              color: "#212126",
              width: "80%",
              maxWidth: "820px",
              minHeight: "335px",
              textTransform: "none",
            }}
          >
            <button
              type="button"
              onClick={togglePopup}
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                backgroundColor: "#DAE9FF",
                border: "none",
                borderRadius: 0,
                fontSize: 30,
                cursor: "pointer",
                color: "#0065F2",
                width: 58,
                height: 58,
              }}
              dangerouslySetInnerHTML={{
                __html: '&times; <span class="screen-reader-text">Close</span>',
              }}
            ></button>
            {data.importantPop}
          </div>
        )}
        {data.conditions.map((condition, index) => (
          <YesNo
            key={index}
            condition={condition.condition}
            onChange={
              condition.condition === "Diabetes"
                ? handleisDiabetes
                : condition.condition === "Heart Conditions"
                ? handleisHeartConditions
                : condition.condition === "End-Stage Renal Disease (ESRD)"
                ? handleisESRD
                : handleIsCSNP
            }
          />
        ))}
      </div>
      <div className="show-for-small-only">
        <h2
          style={{
            fontSize: 30,
            fontWeight: 600,
            lineHeight: "42px",
            textTransform: "uppercase",
            color: "#003A5D",
          }}
        >
          Do you have any of the following conditions?
        </h2>
        <div
          style={{
            paddingBottom: 46,
          }}
        >
          <button
            type="button"
            style={{
              color: "#1B54C2",
              textDecoration: "underline",
              cursor: "pointer",
              fontSize: 18,
            }}
            onClick={togglePopup}
          >
            Why is this important?
          </button>
        </div>
        {showPopup && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#F5F9FD",
              border: "1px solid #ccc",
              padding: "80px 56px",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
              zIndex: 9999,
              fontSize: 25,
              fontWeight: 400,
              lineHeight: "32px",
              color: "#212126",
              width: "80%",
              maxWidth: "820px",
              minHeight: "335px",
              textTransform: "none",
            }}
          >
            <button
              type="button"
              onClick={togglePopup}
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                backgroundColor: "#DAE9FF",
                border: "none",
                borderRadius: 0,
                fontSize: 30,
                cursor: "pointer",
                color: "#0065F2",
                width: 58,
                height: 58,
              }}
              dangerouslySetInnerHTML={{
                __html: '&times; <span class="screen-reader-text">Close</span>',
              }}
            ></button>
            {data.importantPop}
          </div>
        )}
        {data.conditions.map((condition, index) => (
          <YesNo
            key={index}
            condition={condition.condition}
            onChange={
              condition.condition === "Diabetes"
                ? handleisDiabetes
                : condition.condition === "Heart Conditions"
                ? handleisHeartConditions
                : condition.condition === "End-stage Renal Disease"
                ? handleisESRD
                : handleIsCSNP
            }
          />
        ))}
      </div>
      <FullWidthLine />
      <div
        className="show-for-small-only"
        style={{ paddingTop: 24, paddingBottom: 40 }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Link
            to={{
              pathname: "/get-recommendations/preferences",
            }}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              textDecoration: "underline",
              color: "#1B54C2",
              paddingRight: 25,
              cursor: "pointer",
              width: "50%",
              fontSize: 18,
            }}
          >
            Skip this step
          </Link>
          <button
            type="button"
            disabled={
              !(
                isCoverage !== undefined ||
                isVeteran !== undefined ||
                isCSNP !== undefined
              )
            }
            style={{
              width: "50%",
              margin: 0,
              backgroundColor: !(
                isCoverage !== undefined ||
                isVeteran !== undefined ||
                isCSNP !== undefined
              )
                ? "#CACACA"
                : "",
            }}
            className="button"
            onClick={goContinue}
          >
            Continue
          </button>
        </div>
        <Link
          to={{
            pathname: "/get-recommendations/coverage-year",
          }}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: 32,
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              textDecoration: "underline",
              color: "#1B54C2",
            }}
          >
            <AiOutlineLeft style={{ marginRight: "5px" }} />
            Previous step
          </div>
        </Link>
      </div>
      <div
        className="hide-for-small-only"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "24px 0px",
        }}
      >
        <Link
          to={{
            pathname: "/get-recommendations/coverage-year",
          }}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: 25,
              fontWeight: 500,
              lineHeight: "24px",
              textDecoration: "underline",
              color: "#1B54C2",
            }}
          >
            <AiOutlineLeft style={{ marginRight: "5px" }} />
            Previous step
          </div>
        </Link>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Link
            to={{
              pathname: "/get-recommendations/preferences",
            }}
          >
            <div
              style={{
                fontSize: 25,
                fontWeight: 500,
                lineHeight: "24px",
                textDecoration: "underline",
                color: "#1B54C2",
                paddingRight: 25,
                cursor: "pointer",
              }}
            >
              Skip this step
            </div>
          </Link>
          <button
            type="button"
            disabled={
              !(
                isCoverage !== undefined ||
                isVeteran !== undefined ||
                isCSNP !== undefined
              )
            }
            style={{
              margin: 0,
              backgroundColor: !(
                isCoverage !== undefined ||
                isVeteran !== undefined ||
                isCSNP !== undefined
              )
                ? "#CACACA"
                : "",
            }}
            className="button"
            onClick={goContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoveragePart;
